import { Get, HvHostMap } from '../helpers';

export type SessionLiveStateGetResponseItem = {
  playbackUrl: string;
  data: {
    state: 'live' | 'offline';
    timestamp: number;
  };
};

const GetSessionLiveState = (sessionUuid: string): Promise<SessionLiveStateGetResponseItem[]> => {
  return Get({
    host: HvHostMap.eventData,
    path: `/e3-current-stream-state/${sessionUuid}`,
    headers: { 'bl-global-resource': 'false' },
  });
};

export default GetSessionLiveState;
